/* eslint-disable */
// Import a city objects array
import { citiesArr } from './universities-cities';
// Import a universities objects array
import { universityObjArr } from './universities-array';

const init = (containerEl) => {
	// Year
	const MIN_YEAR = 1764;
	const MAX_YEAR = 1864;
	const DELTA_YEARS = MAX_YEAR - MIN_YEAR;

	// Universities in the city
	const MAX_UNI = 8;
	const MIN_UNI = 1;

	// City circle (in px)
	const MAX_CITY_SIZE = 30;
	const MIN_CITY_SIZE = 10;
	const DELTA_CITY_SIZE = MAX_CITY_SIZE - MIN_CITY_SIZE;

	// Fulfill universityPointerArr for each city in citiesArr
	function linkUniAndCity() {
		// Traverse through the citiesArr and
		// 		and on each iteration traverse through the universityObjArr
		// 		and linking unis to the proper city
		for (let i = 0; i < citiesArr.length; i++) {
			for (let uniIndex = 0; uniIndex < universityObjArr.length; uniIndex++) {
				if (universityObjArr[uniIndex].cityIndex === citiesArr[i].cityIndex) {
					citiesArr[i].universityPointerArr.push(uniIndex);
				}
			}
		}
	}
	linkUniAndCity();

	let yearsArr = [];

	// Create an array of unique years
	function fulfillYears() {
		universityObjArr.forEach(function (arrayItem) {
			yearsArr.push(arrayItem.year)
		});

		const set = new Set(yearsArr);
		yearsArr = Array.from(set);
	}

	// Draw tick for every year
	function drawYearTicksTips() {
		// Select parent node element
		const targetParentEl = containerEl.querySelector('.svg-chart__scale');

		// Create temporare fragment
		const tickFragment = new DocumentFragment();
		const tipFragment = new DocumentFragment();

		yearsArr.forEach(year => {
			// Create TICK
			// Create unique DOM element and set class
			const tickEl = buildTick(year);

			// Create TIP
			// Create tip for each year and fulfill it with universities
			const tipEl = buildTip(year);

			// Paste to the fragment
			tickFragment.appendChild(tickEl);
			tipFragment.appendChild(tipEl);
		});

		targetParentEl.appendChild(tickFragment);
		targetParentEl.appendChild(tipFragment);
	}

	// Create node to further put it to the DOM
	function buildTick(year) {
		// Create node and set class
		const tickEl = document.createElement('div');
		tickEl.classList.add('svg-chart__scale-tick');
		tickEl.setAttribute('data-tick-year', year);

		// Calculate how far we position the element from the left side
		const percentage = (year - MIN_YEAR) / DELTA_YEARS * 100;
		tickEl.style.left = `${percentage}%`;

		return tickEl;
	}

	// Create tip for every year
	function buildTip(year) {
		// Create node and set class
		const tipEl = document.createElement('div');
		tipEl.classList.add('svg-chart__scale-tip');
		tipEl.setAttribute('data-target-year', year);
		// console.log(universityObjArr, 'universityObjArr');
		// console.log(year);
		const filterUniversityObjArr = universityObjArr.filter(uni => uni.year === year);

		filterUniversityObjArr.forEach(uni => {
			// if (uni.year === year) {
				const uniNode = document.createElement('p');
				uniNode.classList.add('svg-chart__tip-text');
				uniNode.textContent = `${uni.name}, ${uni.year} г.`

				uniNode.setAttribute('data-cityindex-target', uni.cityIndex);
				tipEl.appendChild(uniNode);

				if (filterUniversityObjArr.length > 1) {
					uniNode.classList.add('cnt');
				}
			// }
		});

		// Calculate how far we position the element from the left side
		const percentage = (year - MIN_YEAR) / DELTA_YEARS * 100;
		tipEl.style.left = `${percentage}%`;

		return tipEl;
	}

	// Draw numbers below the scale
	function drawScaleNumbers() {
		// Select parent node element
		const targetParentEl = containerEl.querySelector('.svg-chart__scale');
		const yearNumberFragment = new DocumentFragment();

		for (let i = MIN_YEAR; i <= MAX_YEAR; i++) {
			if (i % 10 === 0) {
				const yearNumberEl = document.createElement('span');
				yearNumberEl.classList.add('svg-chart__scale-number');
				// Hack
				if (i === 1860) {
					yearNumberEl.classList.add('svg-chart__scale-number--last');
				}

				// Calculate how far we position the element from the left side
				const percentage = (i - MIN_YEAR) / DELTA_YEARS * 100;
				yearNumberEl.style.left = `${percentage}%`;

				yearNumberEl.textContent = String(i);

				yearNumberFragment.appendChild(yearNumberEl);
			}
		}

		targetParentEl.appendChild(yearNumberFragment);
	}

	// Track when we move over/out ticks
	function bindTicksLogic() {
		// Chart Axes Parent El
		const scaleParentEl = document.querySelector('.svg-chart__scale');

		// Circles Parent El
		const circlesParentEl = document.querySelector('.svg-chart__inner-container');

		// Target tip
		let targetTipEl = null;

		// Target circles array
		let targetCirclesArr = [];

		let targetYearsArr = [];

		// Pointer moved in the area of the parentEl
		scaleParentEl.addEventListener('pointerover', (event) => {
			const target = event.target;
			if (target.classList.contains('svg-chart__scale-tick')) {
				// Get a year
				const targetYear = target.getAttribute('data-tick-year');

				// Get a current target tip
				targetTipEl = scaleParentEl.querySelector(`.svg-chart__scale-tip[data-target-year="${targetYear}"]`);
				targetTipEl.classList.add('svg-chart__scale-tip--active');

				// Get circles from the target tip
				const tipUnis = targetTipEl.querySelectorAll('.svg-chart__tip-text');
				tipUnis.forEach(uniCityEl => {
					// Find target index
					const cityindex = uniCityEl.getAttribute('data-cityindex-target');

					// Find proper circle and set active class to it
					const circleEl = circlesParentEl.querySelector(`.svg-chart__city[data-city-index="${cityindex}"]`);
					circleEl.classList.add('svg-chart__city--active');
					console.log(cityindex)

					// Push it to the array
					targetCirclesArr.push(circleEl);

					citiesArr[cityindex]?.universityPointerArr.forEach(uniIndex => {


						if(universityObjArr[uniIndex]?.year === 1852) { // костыль
							// console.log(uniIndex, universityObjArr[uniIndex]?.year)
							// const targetTickEl = scaleParentEl.querySelector(`.svg-chart__scale-tick[data-tick-year="${universityObjArr[26].year}"]`);
							const targetTickEl27 = scaleParentEl.querySelector(`.svg-chart__scale-tick[data-tick-year="${universityObjArr[27].year}"]`);
							// targetTickEl.classList.add('svg-chart__scale-tick--active');
							// targetTickEl27.classList.remove('svg-chart__scale-tick--active');

							// targetYearsArr.push(targetTickEl);
						} else {
							// const targetTickEl = scaleParentEl.querySelector(`.svg-chart__scale-tick[data-tick-year="${universityObjArr[uniIndex]?.year}"]`);
							// targetTickEl.classList.add('svg-chart__scale-tick--active');
							//
							// targetYearsArr.push(targetTickEl);
						}
					});
				});

				// Set active states to circles
				// targetCirclesArr.forEach(circle => {})
				// targetCirclesArr.classList.add('');
			}
		});

		// Pointer moved out of the area of parentEl either moved out from the tick
		scaleParentEl.addEventListener('pointerout', (event) => {
			const target = event.target;
			if (target.classList.contains('svg-chart__scale-tick')) {
				if (targetTipEl !== null) {
					targetTipEl.classList.remove('svg-chart__scale-tip--active');
				}

				if (targetCirclesArr.length > 0) {
					targetCirclesArr.forEach(circle => {
						circle.classList.remove('svg-chart__city--active');
					});

					targetCirclesArr.length = 0;
				}

				if (targetYearsArr.length > 0) {
					targetYearsArr.forEach(tick => {
						tick.classList.remove('svg-chart__scale-tick--active');
					});

					targetYearsArr.length = 0;
				}
			}
			// console.log(event.target);
		});
	}

	function bindCirclesLogic() {
		// Chart Axes Parent El
		const scaleParentEl = document.querySelector('.svg-chart__scale');

		// Circles Parent El
		const circlesParentEl = document.querySelector('.svg-chart__inner-container');

		// let currentCityIndex = 0;
		let targetYearsArr = [];

		// Pointer moved in the area of the parentEl
		circlesParentEl.addEventListener('pointerover', (event) => {
			const target = event.target;
			if (target.classList.contains('svg-chart__city')) {
				const currentCityIndex = target.getAttribute('data-city-index');
				console.log(currentCityIndex, '123')
				citiesArr[currentCityIndex]?.universityPointerArr.forEach(uniIndex => { /// 123
					console.log(uniIndex, universityObjArr[uniIndex].year)
					if(uniIndex === 25) { // костыль
						const targetTickEl = scaleParentEl.querySelector(`.svg-chart__scale-tick[data-tick-year="${universityObjArr[24].year}"]`);

						targetTickEl.classList.add('svg-chart__scale-tick--active');

						targetYearsArr.push(targetTickEl);

					} else if(uniIndex === 27) { // костыль
						const targetTickEl = scaleParentEl.querySelector(`.svg-chart__scale-tick[data-tick-year="${universityObjArr[26].year}"]`);


						targetTickEl.classList.add('svg-chart__scale-tick--active');

						targetYearsArr.push(targetTickEl);
					} else {
						const targetTickEl = scaleParentEl.querySelector(`.svg-chart__scale-tick[data-tick-year="${universityObjArr[uniIndex]?.year}"]`);


						targetTickEl.classList.add('svg-chart__scale-tick--active');

						targetYearsArr.push(targetTickEl);
					}

				});

				if(currentCityIndex === '20') { // костыль
					const targetTickEl = scaleParentEl.querySelector(`.svg-chart__scale-tick[data-tick-year="1859"]`);


					targetTickEl.classList.add('svg-chart__scale-tick--active');

					targetYearsArr.push(targetTickEl);
				}
			}
		});

		// Pointer moved out of the area of parentEl either moved out from the tick
		circlesParentEl.addEventListener('pointerout', (event) => {
			const target = event.target;
			if (target.classList.contains('svg-chart__city')) {
				if (targetYearsArr.length > 0) {
					targetYearsArr.forEach(tick => {
						tick.classList.remove('svg-chart__scale-tick--active');
					});

					targetYearsArr.length = 0;
				}
			}
		});

	}

	// Handle year ticks
	function handleYearTicks() {
		// Draw numbers below the axes
		drawScaleNumbers();

		// fulfill "yearsArr" with unique years
		fulfillYears();

		// Draw tick and tip for each year
		drawYearTicksTips();

		// Bind ticks logic
		bindTicksLogic();

		// Bind circles logic
		bindCirclesLogic();
	}

	// Handle SVG map
	function handleSVGMap() {
		// Select parent node element
		const targetParentEl = containerEl.querySelector('.svg-chart__inner-container');

		// Create temporare fragment
		const circleFragment = new DocumentFragment();
		console.log(citiesArr)
		citiesArr.forEach(city => {
			// Create circle
			const circleEl = document.createElement('div');
			circleEl.classList.add('svg-chart__city');

			// Create city name title
			const circleTextEl = document.createElement('span');
			circleTextEl.classList.add('svg-chart__city-name');
			circleTextEl.textContent = city.title;

			// Create list of unis
			const circleListEl = document.createElement('div');
			circleListEl.classList.add('svg-chart__city-uni-list');

			const uniWrapperFragment = new DocumentFragment();
			city.universityPointerArr.forEach(universityIndex => {
				const uniListItemEl = document.createElement('p');
				uniListItemEl.classList.add('svg-chart__city-uni');

				uniListItemEl.textContent = `${universityObjArr[universityIndex].name}, ${universityObjArr[universityIndex].year} г.`;

				uniWrapperFragment.appendChild(uniListItemEl);
			});
			circleListEl.appendChild(uniWrapperFragment);

			// Calculate the size
			const koef = (city.universityPointerArr.length - MIN_UNI) / MAX_UNI;
			const size = MIN_CITY_SIZE + Math.ceil(DELTA_CITY_SIZE * koef);

			// Set the size to the node
			circleEl.style.width = `${size}px`;
			circleEl.style.height = `${size}px`;

			// Set position
			circleEl.style.left = `${city.coordinates.x}%`;
			circleEl.style.top = `${city.coordinates.y}%`;

			// Set cityindex attribute to a circle
			circleEl.setAttribute('data-city-index', city.cityIndex);

			circleEl.appendChild(circleTextEl);

			circleEl.appendChild(circleListEl);

			circleFragment.appendChild(circleEl);

			setTimeout(() => {
				const listUni = document.querySelectorAll('.svg-chart__city-uni-list');
				listUni.forEach(element => {
					const uni = element.querySelectorAll('.svg-chart__city-uni');
					if (uni.length > 1) {
						element.classList.add('cnt');
					}
				});
			}, 0);
		});

		targetParentEl.appendChild(circleFragment);
	}

	// Create and place years ticks on a year scale
	function placeYearTicks() {
		// Common wrapper for the svg container and year-scale | .svg-chart
		const chartWrapper = containerEl.querySelector('.svg-chart');

		// Container where we're going to place our city-circles
		const svgContainer = chartWrapper.querySelector('.svg-chart__inner-container');

		// Container for a year-scale
		const yearScaleContainer = chartWrapper.querySelector('.svg-chart__scale');

		// Create years ticks and tips scale annotation
		handleYearTicks();

		document.querySelectorAll('.svg-chart__scale-tick').forEach((item, index) => {
			item.setAttribute('data-city-index', citiesArr[index - 1]?.cityIndex);
		});

		/**
		*  Handle svg map
		**/
		// Place cities circles on the map
		handleSVGMap();
	}

	/**
	*  Handle year axes
	**/
	placeYearTicks();

	/**
	*  Init logic on
	**/
	//
};

export default {
	init,
};
/* eslint-enable */
